var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0linear3042203",
    x1: 18.8677,
    y1: 4.22222,
    x2: 4.37037,
    y2: 21.5238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#396CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A9EE"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5796 2H4V22H9.18518C9.76957 22 10.2434 21.5262 10.2434 20.9418V17.3439H12.7273C17.1997 17.3439 20.8254 13.7182 20.8254 9.24573C20.8254 5.24402 17.5813 2 13.5796 2Z",
    fill: "url(#paint0linear3042203)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandora);
export default __webpack_public_path__ + "static/media/pandora.b7b3a147.svg";
export { ForwardRef as ReactComponent };